/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import * as Yup from 'yup';
import {
  Container,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  IconButton,
  InputAdornment,
  TextField,
  Button,
  Stack,
  Typography,
  Box,
  MenuItem,
  OutlinedInput,
  Select,
  InputLabel,
  FormControl,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
} from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import SearchIcon from '@material-ui/icons/Search';
import AddIcon from '@material-ui/icons/Add';
import { useNavigate, useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import { makeStyles } from '@material-ui/styles';
import TokenDecoder from 'src/helpers/TokenDecoder';
import permissionAuth from 'src/utils/permissionAuth';
import Services from '../Service';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import { AESDecryptionParam } from '../../../../helpers/AesEncrypt';
import Divider from '@material-ui/core/Divider';
import BatchDialog from './BatchDialog';
import FreshSKUsDialog from './FreshSKUsDialog';
import FreshCutSKUsDialog from './FreshCutSKUsDialog';
import { normalizeQuantityRows, formatQuantityValue, normalizeBomCountValue } from './quantityUtils';

const useStyles = makeStyles((theme) => ({
  pageTitle: {
    fontSize: '1.5rem',
    fontWeight: 700,
    marginBottom: '1.2rem',
    color: '#1a1a1a',
  },
  sectionCard: {
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    marginBottom: '1.5rem',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
  },
  sectionTitle: {
    fontSize: '1rem',
    fontWeight: 600,
    marginBottom: '0.75rem',
    color: '#1a1a1a',
  },
  skuTableHead: {
    backgroundColor: '#f5f5f5',
  },
  skuTableHeadCell: {
    fontWeight: 600,
    fontSize: '0.82rem',
    color: '#555',
    paddingTop: '8px',
    paddingBottom: '8px',
  },
  skuTableRow: {
    '&:last-child td': { borderBottom: 0 },
  },
  addRowBtn: {
    border: '1px solid #bdbdbd',
    borderRadius: '4px',
    color: '#444',
    textTransform: 'none',
    fontWeight: 500,
    padding: '4px 12px',
    fontSize: '0.82rem',
    marginTop: '0.5rem',
  },
  clearBtn: {
    borderColor: '#e57373',
    color: '#e57373',
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: '20px',
    padding: '5px 22px',
    '&:hover': { backgroundColor: '#ffeaea', borderColor: '#e57373' },
  },
  searchBtn: {
    borderColor: '#1976d2',
    color: '#1976d2',
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: '20px',
    padding: '5px 22px',
    '&:hover': { backgroundColor: '#e3f0ff', borderColor: '#1976d2' },
  },
  saveBtn: {
    backgroundColor: '#1565c0',
    color: '#fff',
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: '6px',
    padding: '8px 28px',
    '&:hover': { backgroundColor: '#0d47a1' },
  },
  addBatchBtn: {
    border: '1px solid #bdbdbd',
    borderRadius: '4px',
    color: '#333',
    textTransform: 'none',
    fontWeight: 500,
    padding: '5px 14px',
    fontSize: '0.85rem',
    whiteSpace: 'nowrap',
  },
  outletChip: {
    margin: '2px',
    backgroundColor: '#e8eaf6',
    fontWeight: 500,
    fontSize: '0.8rem',
  },
  batchSearchInput: {
    '& .MuiInputBase-root': { height: '36px', fontSize: '0.85rem' },
  },
}));

var screenCode = "CUSTOMERORDERPANEL";
export default function CustomerOrderPanelAddEdit(props) {
  const classes = useStyles();
  const navigate = useNavigate();
  // Permission state
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
  });

  // Dropdown data
  const [groupList, setGroupList] = useState([]);
  const [outletList, setOutletList] = useState([]);
  const [orderConfiguration, setOrderConfiguration] = useState(null);
  const [date, setDate] = useState(new Date());
  const [isBackButtonDisabled, setIsBackButtonDisabled] = useState(false);
  const [formData, setFormData] = useState({
    groupID: 0,
    factoryID: 0,
    orderDate: date.toISOString().split('T')[0],
  });

  const customerOrderPanelSchema = Yup.object().shape({
    groupID: Yup.number().min(1, 'Please Select Group').required('Group Required'),
    factoryID: Yup.number().min(1, 'Please Select Outlet').required('Outlet Required'),
    orderDate: Yup.date().min(1, 'Please Select Date').required('Date required')
  });

  const formik = useFormik({
    initialValues: {
      groupID: formData.groupID,
      factoryID: formData.factoryID,
      orderDate: formData.orderDate,
    },
    validationSchema: customerOrderPanelSchema,
    onSubmit: (values) => {
      trackPromise(handleSaveOrder(values))
    }
  });

  const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

  // Batch rows state
  const [batchRows, setBatchRows] = useState([]);
  const [batchDialogOpen, setBatchDialogOpen] = useState(false);
  const [isBatchUpdate, setIsBatchUpdate] = useState(false);
  const [batchUpdateIndex, setBatchUpdateIndex] = useState(null);
  // Fresh SKUs state
  const [freshSKUsRows, setFreshSKUsRows] = useState([]);
  const [freshSKUsDialogOpen, setFreshSKUsDialogOpen] = useState(false);
  const [isFreshSKUsUpdate, setIsFreshSKUsUpdate] = useState(false);
  const [freshSKUsUpdateIndex, setFreshSKUsUpdateIndex] = useState(null);
  // Fresh Cut SKU state
  const [freshCutSKUsRows, setFreshCutSKUsRows] = useState([]);
  const [freshCutSKUsDialogOpen, setFreshCutSKUsDialogOpen] = useState(false);
  const [isFreshCutSKUsUpdate, setIsFreshCutSKUsUpdate] = useState(false);
  const [freshCutSKUsUpdateIndex, setFreshCutSKUsUpdateIndex] = useState(null);

  // Delete confirmation state
  const [deleteConfirmation, setDeleteConfirmation] = useState({
    open: false,
    rowType: null, // 'batch', 'freshSku', 'freshCutSku'
    index: null
  });
  const [isDeleting, setIsDeleting] = useState(false);

  const [pageProps, setPageProps] = useState({
    editingID: 0,
    isEdit: false,
    pageName: 'Customer Order Panel',
  });
  const hasShownBlockToastRef = useRef(false);

  const { customerOrderID } = useParams();

  useEffect(() => {
    const decrypted = AESDecryptionParam(customerOrderID);
    if (decrypted != 0) {
      setPageProps({
        ...pageProps,
        isEdit: true,
        editingID: parseInt(decrypted),
        pageName: 'Update Customer Order',
      });
      trackPromise(GetCustomerOrderDetailsByCustomerOrderID(parseInt(decrypted)));
    }
    getPermissions();
  }, []);

  useEffect(() => {
    if (values.groupID !== '0') {
      trackPromise(loadOutlets(values.groupID));
      trackPromise(loadOrderConfiguration(values.groupID));
    }
  }, [values.groupID]);

  async function getPermissions() {
    var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find((p) => p.permissionCode == 'ADDEDITCUSTOMERORDERPANEL');
    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find((p) => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find((p) => p.permissionCode == 'FACTORYDROPDOWN');
    setPermissions({
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });



    setValues({
      ...values,
      groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
      factoryID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
    });

    trackPromise(loadGroups());
  }

  async function loadGroups() {
    var res = await Services.GetAllGroupsForDropDown();
    if (res != null) setGroupList(res);
  }

  async function loadOutlets(groupID) {
    var res = await Services.GetKfcOutletsByGroupID(groupID);
    if (res != null) setOutletList(res);
  }

  async function loadOrderConfiguration(groupID) {
    if (!groupID || groupID === '0') {
      setOrderConfiguration(null);
      return;
    }

    var res = await Services.GetCustomerOrderConfigurationByGroupID(groupID);
    if (res != null) {
      const config = Array.isArray(res) ? res[0] : res;
      setOrderConfiguration(config);
    } else {
      setOrderConfiguration(null);
    }
  }

  function parseTimeSpan(configurationTime) {
    if (!configurationTime) return null;
    if (typeof configurationTime === 'string') {
      const parts = configurationTime.split(':').map((part) => parseInt(part, 10));
      return {
        hours: parts[0] || 0,
        minutes: parts[1] || 0,
        seconds: parts[2] || 0,
      };
    }
    if (typeof configurationTime === 'object') {
      return {
        hours: configurationTime.hours || configurationTime.Hours || 0,
        minutes: configurationTime.minutes || configurationTime.Minutes || 0,
        seconds: configurationTime.seconds || configurationTime.Seconds || 0,
      };
    }
    return null;
  }

  function formatConfigurationTime(configurationTime) {
    const time = parseTimeSpan(configurationTime);
    if (!time) return '';

    const hour = time.hours % 12 || 12;
    const minutes = String(time.minutes).padStart(2, '0');
    const suffix = time.hours >= 12 ? 'PM' : 'AM';

    return `${hour}:${minutes} ${suffix}`;
  }

  function isTodayOrderBlocked(orderDate) {
    if (!orderConfiguration || !orderConfiguration.isActive || !orderDate) {
      return false;
    }

    const configTime = parseTimeSpan(orderConfiguration.configurationTime);
    if (!configTime) {
      return false;
    }

    const selectedDate = new Date(orderDate + 'T00:00:00');
    const today = new Date();
    const todayDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());

    if (selectedDate.getTime() !== todayDate.getTime()) {
      return false;
    }

    const cutoff = new Date(selectedDate);
    cutoff.setHours(configTime.hours, configTime.minutes, configTime.seconds, 0);

    return today >= cutoff;
  }

  function isPastOrderDate(orderDate) {
    if (!orderDate) return false;

    const selectedDate = new Date(orderDate + 'T00:00:00');
    const today = new Date();
    const todayDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());

    return selectedDate.getTime() < todayDate.getTime();
  }

  function getOrderBlockMessage() {
    if (!orderConfiguration || !orderConfiguration.isActive) return '';
    const timeLabel = formatConfigurationTime(orderConfiguration.configurationTime);
    return `Orders for today cannot be added after ${timeLabel}.`;
  }

  const isNewOrderBlocked = !pageProps.isEdit && isTodayOrderBlocked(values.orderDate);
  const isUpdateBlocked = pageProps.isEdit && isPastOrderDate(values.orderDate);

  useEffect(() => {
    if (!isNewOrderBlocked) {
      hasShownBlockToastRef.current = false;
      return;
    }

    if (!hasShownBlockToastRef.current) {
      toast.error(getOrderBlockMessage() || 'Cannot add a customer order for today after cutoff time.');
      hasShownBlockToastRef.current = true;
    }
  }, [isNewOrderBlocked, orderConfiguration, values.orderDate, pageProps.isEdit]);

  // ─── Batch row handlers ────────────────────────────────────────────────
  function handleAddBatchRow() {
    if (isNewOrderBlocked) {
      toast.error(getOrderBlockMessage() || 'Cannot add a customer order for today after cutoff time.');
      return;
    }
    setBatchDialogOpen(true);
    setIsBatchUpdate(false);
  }

  function handleBatchDetailsEdit(row, index) {
    setIsBatchUpdate(true);
    setBatchUpdateIndex(index);
    setBatchDialogOpen(true);
  }

  function handleRemoveBatchRow(index) {
    setDeleteConfirmation({
      open: true,
      rowType: 'batch',
      index: index
    });
  }

  // ─── Fresh SKU handlers ───────────────────────────────────────────────
  function handleAddFreshSKURow() {
    if (isNewOrderBlocked) {
      toast.error(getOrderBlockMessage() || 'Cannot add a customer order for today after cutoff time.');
      return;
    }
    setFreshSKUsDialogOpen(true);
    setIsFreshSKUsUpdate(false);
  }

  function handleFreshSKUEdit(row, index) {
    setIsFreshSKUsUpdate(true);
    setFreshSKUsUpdateIndex(index);
    setFreshSKUsDialogOpen(true);
  }

  function handleRemoveFreshSKURow(index) {
    setDeleteConfirmation({
      open: true,
      rowType: 'freshSku',
      index: index
    });
  }

  // ─── Fresh Cut SKU handlers ────────────────────────────────────────────
  function handleAddFreshCutSKURow() {
    if (isNewOrderBlocked) {
      toast.error(getOrderBlockMessage() || 'Cannot add a customer order for today after cutoff time.');
      return;
    }
    setFreshCutSKUsDialogOpen(true);
    setIsFreshCutSKUsUpdate(false);
  }

  function handleFreshCutSKUEdit(row, index) {
    setIsFreshCutSKUsUpdate(true);
    setFreshCutSKUsUpdateIndex(index);
    setFreshCutSKUsDialogOpen(true);
  }

  function handleRemoveFreshCutSKURow(index) {
    setDeleteConfirmation({
      open: true,
      rowType: 'freshCutSku',
      index: index
    });
  }

  // ─── Delete confirmation handler ────────────────────────────────────────
  async function handleConfirmDelete() {
    const { rowType, index } = deleteConfirmation;
    setIsDeleting(true);

    try {
      if (rowType === 'batch') {
        const row = batchRows[index];
        const toDelete = [];
        row.details.forEach(detail => {
          if (detail.customerOrderDetailsID != null && detail.customerOrderDetailsID !== 0) {
            toDelete.push({
              customerOrderTypeID: 1,
              customerOrderDetailsID: detail.customerOrderDetailsID,
              productCategoryID: row.productCategoryID,
              productID: row.productID,
              productCode: row.productCode,
              productName: row.productName,
              measuringUnitID: detail.measuringUnitID,
              quantity: row.quantity * (detail.bomQuantity == undefined ? detail.quantity : detail.bomQuantity),
              isBom: true,
              isCut: false,
              bomProductID: detail.bomProductID,
              bomProductCode: detail.bomProductCode,
              bomProductName: detail.bomProductName,
              bomQuantity: detail.bomQuantity == undefined ? detail.quantity : detail.bomQuantity,
              bomCount: normalizeBomCountValue(row.quantity)
            });
          }
        });

        if (toDelete.length > 0 && pageProps.isEdit) {
          const model = buildDeletePayload(toDelete);
          const res = await Services.DeleteCustomerOrderDetails(model);
          if (res.statusCode == 'Success') {
            setIsBackButtonDisabled(true);
            toast.success(res.message);
            setBatchRows((prev) => prev.filter((r, i) => i !== index));
          } else {
            toast.error(res.message || 'Delete failed');
          }
        } else {
          setBatchRows((prev) => prev.filter((r, i) => i !== index));
        }

      } else if (rowType === 'freshSku') {
        const row = freshSKUsRows[index];
        const toDelete = [];
        (row.details || []).forEach(detail => {
          if (detail.customerOrderDetailsID != null && detail.customerOrderDetailsID !== 0) {
            toDelete.push({
              customerOrderTypeID: 2,
              customerOrderDetailsID: detail.customerOrderDetailsID,
              productCategoryID: row.productCategoryID,
              productID: row.productID,
              productCode: row.productCode,
              productName: row.productName,
              measuringUnitID: row.measuringUnit,
              quantity: row.quantity,
              isBom: false,
              isCut: false,
              bomProductID: 0,
              bomProductCode: '',
              bomProductName: '',
              bomQuantity: 0,
              bomCount: 0
            });
          }
        });

        if (toDelete.length > 0 && pageProps.isEdit) {

          const model = buildDeletePayload(toDelete);
          const res = await Services.DeleteCustomerOrderDetails(model);
          if (res.statusCode == 'Success') {
            setIsBackButtonDisabled(true);
            toast.success(res.message);
            setFreshSKUsRows((prev) => prev.filter((r, i) => i !== index));
          } else {
            toast.error(res.message || 'Delete failed');
          }
        } else {
          setFreshSKUsRows((prev) => prev.filter((r, i) => i !== index));
        }

      } else if (rowType === 'freshCutSku') {
        const row = freshCutSKUsRows[index];
        const toDelete = [];
        (row.details || []).forEach(detail => {
          if (detail.customerOrderDetailsID != null && detail.customerOrderDetailsID !== 0) {
            toDelete.push({
              customerOrderTypeID: 3,
              customerOrderDetailsID: detail.customerOrderDetailsID,
              productCategoryID: row.productCategoryID,
              productID: row.productID,
              productCode: row.productCode,
              productName: row.productName,
              measuringUnitID: row.measuringUnit,
              quantity: row.quantity,
              isBom: false,
              isCut: true,
              bomProductID: detail.bomProductID,
              bomProductCode: detail.bomProductCode,
              bomProductName: detail.bomProductName,
              bomQuantity: 0,
              bomCount: 0
            });
          }
        });

        if (toDelete.length > 0 && pageProps.isEdit) {
          const model = buildDeletePayload(toDelete);
          const res = await Services.DeleteCustomerOrderDetails(model);
          if (res.statusCode == 'Success') {
            setIsBackButtonDisabled(true);
            toast.success(res.message);
            setFreshCutSKUsRows((prev) => prev.filter((r, i) => i !== index));
          } else {
            toast.error(res.message || 'Delete failed');
          }
        } else {
          setFreshCutSKUsRows((prev) => prev.filter((r, i) => i !== index));
        }
      }
    } catch (err) {
      toast.error('An error occurred while deleting.');
    } finally {
      setIsDeleting(false);
    }

    setDeleteConfirmation({
      open: false,
      rowType: null,
      index: null
    });
  }

  function handleCancelDelete() {
    setDeleteConfirmation({
      open: false,
      rowType: null,
      index: null
    });
  }

  function buildDeletePayload(toDelete) {
    const outlet = outletList.find((o) => o.factoryID === parseInt(values.factoryID));
    const totallength = parseInt(batchRows.length) + parseInt(freshSKUsRows.length) + parseInt(freshCutSKUsRows.length);
    return {
      customerOrderID: pageProps.editingID,
      groupID: parseInt(values.groupID) || 0,
      outletID: parseInt(values.factoryID) || 0,
      outletCode: outlet?.factoryCode ?? null,
      batchCount: totallength === 1 ? 0 : parseInt(batchRows.length) || 0,
      freshSkuCount: totallength === 1 ? 0 : parseInt(freshSKUsRows.length) || 0,
      freshCutSkuCount: totallength === 1 ? 0 : parseInt(freshCutSKUsRows.length) || 0,
      orderDate: values.orderDate ? values.orderDate.split('T')[0] : new Date().toISOString().split('T')[0],
      customerOrderDetails: toDelete,
      createdBy: parseInt(TokenDecoder.getUserIDFromToken())
    };
  }

  // ─── Get update details ────────────────────────────────────────────────
  async function GetCustomerOrderDetailsByCustomerOrderID(customerOrderID) {
    var res = await Services.GetCustomerOrderDetailsByCustomerOrderID(customerOrderID);
    if (res != null) {
      var outlets = await Services.GetKfcOutletsByGroupID(res.groupID);
      if (outlets != null) {
        setOutletList(outlets);
      }

      setValues((prevState) => ({
        ...prevState,
        groupID: res.groupID,
        factoryID: res.outletID,
        orderDate: res.orderDate.split('T')[0]
      }));

      setBatchRows(normalizeQuantityRows(res.batchDetails || []));
      setFreshSKUsRows(normalizeQuantityRows(res.freshSku || []));
      setFreshCutSKUsRows(normalizeQuantityRows(res.freshCutSku || []));
    }

  }

  function validateQuantityValue(value) {
    if (value === null || value === undefined || value === '') {
      return false;
    }

    const stringValue = String(value).trim();
    if (stringValue === '' || !/^\d*\.?\d{0,3}$/.test(stringValue)) {
      return false;
    }

    const numericValue = Number(stringValue);
    return Number.isFinite(numericValue) && numericValue > 0;
  }

  function validateOrderQuantities(batchRows, freshSKUsRows, freshCutSKUsRows) {
    const invalidItems = [];

    batchRows.forEach((row, index) => {
      if (!validateQuantityValue(row?.quantity)) {
        invalidItems.push(`Recipe product row ${index + 1} has an invalid quantity.`);
      }
    });

    freshSKUsRows.forEach((row, index) => {
      if (!validateQuantityValue(row?.quantity)) {
        invalidItems.push(`Fresh SKU row ${index + 1} has an invalid quantity.`);
      }
    });

    freshCutSKUsRows.forEach((row, index) => {
      if (!validateQuantityValue(row?.quantity)) {
        invalidItems.push(`Fresh cut SKU row ${index + 1} has an invalid quantity.`);
      }
    });

    return invalidItems;
  }

  // ─── Save / Update ──────────────────────────────────────────────────────────────
  async function handleSaveOrder() {
    if (isNewOrderBlocked) {
      toast.error(getOrderBlockMessage() || 'Cannot save a customer order for today after cutoff time.');
      return;
    }

    if (isUpdateBlocked) {
      toast.error('Cannot update customer orders for past dates.');
      return;
    }

    const validationErrors = validateOrderQuantities(batchRows, freshSKUsRows, freshCutSKUsRows);
    if (validationErrors.length > 0) {
      toast.error(validationErrors[0]);
      return;
    }

    const found = outletList.find(x => x.factoryID == values.factoryID)
    if (found) {
      if (pageProps.isEdit == false) {
        const result = formatSaveData(batchRows, freshSKUsRows, freshCutSKUsRows);
        if (result.length == 0) {
          toast.warning('Please fill Customer Order details before saving.');
          return
        }
        let model = {
          groupID: parseInt(values.groupID),
          outletID: parseInt(values.factoryID),
          outletCode: outletList.find((o) => o.factoryID === parseInt(values.factoryID))?.factoryCode,
          batchCount: parseInt(batchRows.length),
          freshSkuCount: parseInt(freshSKUsRows.length),
          freshCutSkuCount: parseInt(freshCutSKUsRows.length),
          customerOrderDetails: result,
          orderDate: values.orderDate.split('T')[0],
          createdBy: parseInt(TokenDecoder.getUserIDFromToken())
        }
        console.log('model', model)
        var res = await Services.SaveCustomerOrderDetails(model);
        if (res.statusCode == 'Success') {
          toast.success(res.message);
          navigate('/dashboard/CustomerOrderPanel')
        }
        else {
          toast.error(res.message);
        }
      }
      else {
        const result = formatUpdateData(batchRows, freshSKUsRows, freshCutSKUsRows);
        if (result.length == 0 && pageProps.isEdit === false) {
          toast.warning('Please fill Customer Order details before saving.');
          return
        }
        let model = {
          customerOrderID: pageProps.editingID,
          groupID: parseInt(values.groupID),
          outletID: parseInt(values.factoryID),
          outletCode: outletList.find((o) => o.factoryID === parseInt(values.factoryID))?.factoryCode,
          batchCount: parseInt(batchRows.length),
          freshSkuCount: parseInt(freshSKUsRows.length),
          freshCutSkuCount: parseInt(freshCutSKUsRows.length),
          customerOrderDetails: result,
          orderDate: values.orderDate.split('T')[0],
          createdBy: parseInt(TokenDecoder.getUserIDFromToken())
        }
        var res = await Services.UpdateCustomerOrderDetails(model);
        if (res.statusCode == 'Success') {
          toast.success(res.message);
          navigate('/dashboard/CustomerOrderPanel')
        }
        else {
          toast.error(res.message);
        }
      }
    }
    else {
      toast.error('Selected outlet is not valid. Please select a valid outlet.');
    }
  }

  function formatUpdateData(batchRows, freshSKUsRows, freshCutSKUsRows) {
    let result = [];
    if (batchRows.length != 0) {
      batchRows.forEach(row =>
        row.details.forEach(detail =>
          result.push({
            customerOrderTypeID: 1,
            customerOrderDetailsID: detail.customerOrderDetailsID != null ? detail.customerOrderDetailsID : 0,
            productCategoryID: row.productCategoryID,
            productID: row.productID,
            productCode: row.productCode,
            productName: row.productName,
            measuringUnitID: detail.measuringUnitID,
            quantity: row.quantity * (detail.bomQuantity == undefined ? detail.quantity : detail.bomQuantity),
            isBom: true,
            isCut: false,
            bomProductID: detail.bomProductID,
            bomProductCode: detail.bomProductCode,
            bomProductName: detail.bomProductName,
            bomQuantity: detail.bomQuantity == undefined ? detail.quantity : detail.bomQuantity,
            bomCount: normalizeBomCountValue(row.quantity)
          })
        )
      )
    }
    if (freshSKUsRows.length != 0) {
      freshSKUsRows.forEach(row => {
        if (row.details && row.details.length > 0) {
          row.details.forEach(detail =>
            result.push({
              customerOrderTypeID: 2,
              customerOrderDetailsID: detail.customerOrderDetailsID != null ? detail.customerOrderDetailsID : 0,
              productCategoryID: row.productCategoryID,
              productID: row.productID,
              productCode: row.productCode,
              productName: row.productName,
              measuringUnitID: row.measuringUnit,
              quantity: row.quantity,
              isBom: false,
              isCut: false,
              bomProductID: 0,
              bomProductCode: '',
              bomProductName: '',
              bomQuantity: 0,
              bomCount: 0
            })
          )
        } else {
          result.push({
            customerOrderTypeID: 2,
            customerOrderDetailsID: 0,
            productCategoryID: row.productCategoryID,
            productID: row.productID,
            productCode: row.productCode,
            productName: row.productName,
            measuringUnitID: row.measuringUnit,
            quantity: row.quantity,
            isBom: false,
            isCut: false,
            bomProductID: 0,
            bomProductCode: '',
            bomProductName: '',
            bomQuantity: 0,
            bomCount: 0
          })
        }
      })
    }
    if (freshCutSKUsRows.length != 0) {
      freshCutSKUsRows.forEach(row => {
        if (row.details && row.details.length > 0) {
          row.details.forEach(detail =>
            result.push({
              customerOrderTypeID: 3,
              customerOrderDetailsID: detail.customerOrderDetailsID != null ? detail.customerOrderDetailsID : 0,
              productCategoryID: row.productCategoryID,
              productID: row.productID,
              productCode: row.productCode,
              productName: row.productName,
              measuringUnitID: row.measuringUnit,
              quantity: row.quantity,
              isBom: false,
              isCut: true,
              bomProductID: detail.bomProductID,
              bomProductCode: detail.bomProductCode,
              bomProductName: detail.bomProductName,
              bomQuantity: 0,
              bomCount: 0
            })
          )
        } else {
          result.push({
            customerOrderTypeID: 3,
            customerOrderDetailsID: 0,
            productCategoryID: row.productCategoryID,
            productID: row.productID,
            productCode: row.productCode,
            productName: row.productName,
            measuringUnitID: row.measuringUnit,
            quantity: row.quantity,
            isBom: false,
            isCut: true,
            bomProductID: 0,
            bomProductCode: '',
            bomProductName: '',
            bomQuantity: 0,
            bomCount: 0
          })
        }
      })
    }
    return result;
  }

  function formatSaveData(batchRows, freshSKUsRows, freshCutSKUsRows) {
    let result = [];
    if (batchRows.length != 0) {
      batchRows.forEach(row =>
        row.details.forEach(detail =>
          result.push({
            customerOrderTypeID: 1,
            productCategoryID: row.productCategoryID,
            productID: row.productID,
            productCode: row.productCode,
            productName: row.productName,
            measuringUnitID: detail.measuringUnitID,
            quantity: Number(row.quantity) * Number(detail.quantity),
            isBom: true,
            isCut: false,
            bomProductID: detail.bomProductID,
            bomProductCode: detail.bomProductCode,
            bomProductName: detail.bomProductName,
            bomQuantity: detail.quantity,
            bomCount: normalizeBomCountValue(row.quantity)
          })
        )
      )
    }
    if (freshSKUsRows.length != 0) {
      freshSKUsRows.forEach(row =>
        result.push({
          customerOrderTypeID: 2,
          productCategoryID: row.productCategoryID,
          productID: row.productID,
          productCode: row.productCode,
          productName: row.productName,
          measuringUnitID: row.measuringUnit,
          quantity: row.quantity,
          isBom: false,
          isCut: false,
          bomProductID: 0,
          bomProductCode: '',
          bomProductName: '',
          bomQuantity: 0,
          bomCount: 0
        })
      )
    }
    if (freshCutSKUsRows.length != 0) {
      freshCutSKUsRows.forEach(row =>
        row.details.forEach(detail =>
          result.push({
            customerOrderTypeID: 3,
            productCategoryID: row.productCategoryID,
            productID: row.productID,
            productCode: row.productCode,
            productName: row.productName,
            measuringUnitID: row.measuringUnit,
            quantity: row.quantity,
            isBom: false,
            isCut: true,
            bomProductID: detail.bomProductID,
            bomProductCode: detail.bomProductCode,
            bomProductName: detail.bomProductName,
            bomQuantity: 0,
            bomCount: 0
          })
        )
      )
    }
    return result;
  }

  return (
    <>
      <LoadingComponent />
      <Page title="Customer Order Panel | FAPS">
        <Container maxWidth="lg">
          {/* Back header */}
          <CommonPageHeader
            path={'/dashboard/CustomerOrderPanel'}
            btname="Back"
            pageName={pageProps.pageName}
            leftButtonHidden={isBackButtonDisabled}
          />

          {/* ── Filters Row ─────────────────────────────────────────── */}
          <FormikProvider value={formik}>
            <ToastContainer
              position="bottom-right"
              pauseOnHover
            />
            <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <Stack spacing={4}>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Group *"
                    value={formik.values.groupID}
                    onChange={formik.handleChange}
                    {...getFieldProps('groupID')}
                    error={Boolean(touched.groupID && errors.groupID)}
                    helperText={touched.groupID && errors.groupID}
                    InputProps={{
                      readOnly: !permissionList.isGroupFilterEnabled || pageProps.isEdit == true
                    }}
                  >
                    <MenuItem key={0} value={0}> Select Group</MenuItem>
                    {groupList.map((option) => (
                      option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                        {option.groupName}
                      </MenuItem> : null
                    ))}
                  </TextField>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Outlet *"
                    value={formik.values.factoryID}
                    onChange={formik.handleChange}
                    {...getFieldProps('factoryID')}
                    error={Boolean(touched.factoryID && errors.factoryID)}
                    helperText={touched.factoryID && errors.factoryID}
                    InputProps={{
                      readOnly: !permissionList.isFactoryFilterEnabled || pageProps.isEdit == true
                    }}
                  >
                    <MenuItem key={0} value={0}> Select Outlet</MenuItem>
                    {outletList.map((option) => (
                      <MenuItem key={option.factoryID} value={option.factoryID}>
                        {option.factoryName}
                      </MenuItem>
                    ))}
                  </TextField>
                  <TextField
                    fullWidth
                    id="outlined-start-adornment"
                    size="small"
                    label="Date *"
                    type="Date"
                    value={formik.values.orderDate}
                    onChange={formik.handleChange}
                    {...getFieldProps('orderDate')}
                    error={Boolean(touched.orderDate && errors.orderDate)}
                    helperText={touched.orderDate && errors.orderDate}
                    InputProps={{
                      startAdornment: <InputAdornment position="start"></InputAdornment>,
                      readOnly: pageProps.isEdit == true,
                    }}
                    inputProps={{
                      min: new Date().toISOString().split('T')[0]
                    }}
                  >
                  </TextField>
                </Stack>
              </Stack>
              <br /><Divider variant="middle" /><br />
              {/* ── Batch Details ────────────────────────────────────────── */}
              <Box mb={2.5}>
                <Card className={classes.sectionCard} style={{ marginBottom: 0 }}>
                  <CardContent style={{ paddingBottom: '12px' }}>
                    <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1.5}>
                      <Typography className={classes.sectionTitle}>Recipe Products</Typography>
                      <Button
                        variant="outlined"
                        size="small"
                        className={classes.addBatchBtn}
                        startIcon={<AddIcon style={{ fontSize: '0.9rem' }} />}
                        onClick={handleAddBatchRow}
                        disabled={isNewOrderBlocked || isUpdateBlocked}
                      >
                        Add New Recipe Product
                      </Button>
                    </Stack>
                    {/* Batch table header */}
                    <TableContainer>
                      <Table size="small">
                        <TableHead>
                          <TableRow style={{ backgroundColor: '#f9f9f9' }}>
                            <TableCell className={classes.skuTableHeadCell}>Batch Code</TableCell>
                            <TableCell className={classes.skuTableHeadCell}>Batch</TableCell>
                            <TableCell className={classes.skuTableHeadCell}>Quantity</TableCell>
                            <TableCell className={classes.skuTableHeadCell}>Action</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {batchRows.length == 0 ?
                            <TableRow className={classes.skuTableRow}>
                              <TableCell colSpan={4} align="center" style={{ fontStyle: 'italic', color: '#777' }}>
                                No Data Available
                              </TableCell>
                            </TableRow>
                            : <>
                              {batchRows.map((row, index) => (
                                <TableRow key={row.id} className={classes.skuTableRow}>
                                  <TableCell >
                                    {row.productCode}
                                  </TableCell>
                                  <TableCell >
                                    {row.productName}
                                  </TableCell>
                                  <TableCell >
                                    {(row.quantity)}
                                  </TableCell>
                                  <TableCell >
                                    <IconButton
                                      size="small"
                                      onClick={() => handleBatchDetailsEdit(row, index)}
                                    >
                                      <EditIcon fontSize="small" />
                                    </IconButton>
                                    <IconButton size="small" onClick={() => handleRemoveBatchRow(index)}>
                                      <DeleteIcon fontSize="small" />
                                    </IconButton>
                                  </TableCell>
                                </TableRow>
                              ))}</>}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </CardContent>
                </Card>
              </Box>
              {/* ── Fresh SKUs ───────────────────────────────────────────── */}
              <Box mb={2.5}>
                <Card className={classes.sectionCard} style={{ marginBottom: 0 }}>
                  <CardContent style={{ paddingBottom: '12px' }}>
                    <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1.5}>
                      <Typography className={classes.sectionTitle}>Fresh Products</Typography>
                      <Button
                        variant="outlined"
                        size="small"
                        className={classes.addBatchBtn}
                        startIcon={<AddIcon style={{ fontSize: '0.9rem' }} />}
                        onClick={handleAddFreshSKURow}
                        disabled={isNewOrderBlocked || isUpdateBlocked}
                      >
                        Add Fresh Products
                      </Button>
                    </Stack>
                    <TableContainer component={Paper} elevation={0}>
                      <Table size="small">
                        <TableHead className={classes.skuTableHead}>
                          <TableRow>
                            <TableCell className={classes.skuTableHeadCell}>Product Code</TableCell>
                            <TableCell className={classes.skuTableHeadCell}>Product Name</TableCell>
                            <TableCell className={classes.skuTableHeadCell}>UOM</TableCell>
                            <TableCell className={classes.skuTableHeadCell}>Qty</TableCell>
                            <TableCell className={classes.skuTableHeadCell}>Action</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {freshSKUsRows.length == 0 ?
                            <TableRow className={classes.skuTableRow}>
                              <TableCell colSpan={5} align="center" style={{ fontStyle: 'italic', color: '#777' }}>
                                No Data Available
                              </TableCell>
                            </TableRow>
                            : <>
                              {freshSKUsRows.map((row, index) => (
                                <TableRow key={row.id} className={classes.skuTableRow}>
                                  <TableCell>
                                    {row.productCode}
                                  </TableCell>
                                  <TableCell>
                                    {row.productName}
                                  </TableCell>
                                  <TableCell>
                                    {row.measuringUnit == 1 ? 'Units' : row.measuringUnit == 2 ? 'KG' : 'G'}
                                  </TableCell>
                                  <TableCell>
                                    {formatQuantityValue(row.quantity)}
                                  </TableCell>
                                  <TableCell>
                                    <IconButton
                                      size="small"
                                      onClick={() => handleFreshSKUEdit(row, index)}
                                    >
                                      <EditIcon fontSize="small" />
                                    </IconButton>
                                    <IconButton
                                      size="small"
                                      onClick={() => handleRemoveFreshSKURow(index)}
                                    >
                                      <DeleteIcon fontSize="small" />
                                    </IconButton>
                                  </TableCell>
                                </TableRow>
                              ))}</>}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </CardContent>
                </Card>
              </Box>
              {/* ── Fresh Cut SKUs ───────────────────────────────────────── */}
              <Box mb={3}>
                <Card className={classes.sectionCard} style={{ marginBottom: 0 }}>
                  <CardContent style={{ paddingBottom: '12px' }}>
                    <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1.5}>
                      <Typography className={classes.sectionTitle}>Fresh Cut Products</Typography>
                      <Button
                        variant="outlined"
                        size="small"
                        className={classes.addBatchBtn}
                        startIcon={<AddIcon style={{ fontSize: '0.9rem' }} />}
                        onClick={handleAddFreshCutSKURow}
                        disabled={isNewOrderBlocked || isUpdateBlocked}
                      >
                        Add Fresh Cut Products
                      </Button>
                    </Stack>
                    <TableContainer component={Paper} elevation={0}>
                      <Table size="small">
                        <TableHead className={classes.skuTableHead}>
                          <TableRow>
                            <TableCell className={classes.skuTableHeadCell}>Product Code</TableCell>
                            <TableCell className={classes.skuTableHeadCell}>Product Name</TableCell>
                            <TableCell className={classes.skuTableHeadCell}>UOM</TableCell>
                            <TableCell className={classes.skuTableHeadCell}>Qty</TableCell>
                            <TableCell className={classes.skuTableHeadCell}>Action</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {freshCutSKUsRows.length == 0 ?
                            <TableRow className={classes.skuTableRow}>
                              <TableCell colSpan={5} align="center" style={{ fontStyle: 'italic', color: '#777' }}>
                                No Data Available
                              </TableCell>
                            </TableRow>
                            : <>
                              {freshCutSKUsRows.map((row, index) => (
                                <TableRow key={row.productID} className={classes.skuTableRow}>
                                  <TableCell>
                                    {row.productCode}
                                  </TableCell>
                                  <TableCell>
                                    {row.productName}
                                  </TableCell>
                                  <TableCell>
                                    {row.measuringUnit == 1 ? 'Units' : row.measuringUnit == 2 ? 'KG' : 'G'}
                                  </TableCell>
                                  <TableCell>
                                    {formatQuantityValue(row.quantity)}
                                  </TableCell>
                                  <TableCell>
                                    <IconButton
                                      size="small"
                                      onClick={() => handleFreshCutSKUEdit(row, index)}
                                    >
                                      <EditIcon fontSize="small" />
                                    </IconButton>
                                    <IconButton
                                      size="small"
                                      onClick={() => handleRemoveFreshCutSKURow(index)}
                                    >
                                      <DeleteIcon fontSize="small" />
                                    </IconButton>
                                  </TableCell>
                                </TableRow>
                              ))}</>}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </CardContent>
                </Card>
                {batchDialogOpen == true ?
                  <BatchDialog open={batchDialogOpen} setOpen={setBatchDialogOpen} setBatchRows={setBatchRows} isUpdate={isBatchUpdate} batchRows={batchRows} index={batchUpdateIndex} />
                  : null}
                {freshSKUsDialogOpen == true ?
                  <FreshSKUsDialog open={freshSKUsDialogOpen} setOpen={setFreshSKUsDialogOpen} setFreshSKUsRows={setFreshSKUsRows} isUpdate={isFreshSKUsUpdate} freshSKUsRows={freshSKUsRows} index={freshSKUsUpdateIndex} />
                  : null}
                {freshCutSKUsDialogOpen == true ?
                  <FreshCutSKUsDialog open={freshCutSKUsDialogOpen} setOpen={setFreshCutSKUsDialogOpen} setFreshCutSKUsRows={setFreshCutSKUsRows} isUpdate={isFreshCutSKUsUpdate} freshCutSKUsRows={freshCutSKUsRows} index={freshCutSKUsUpdateIndex} />
                  : null}
              </Box>
              {/* ── Save Order ───────────────────────────────────────────── */}
              <Stack direction="row" justifyContent="flex-end" mb={3}>
                <Button
                  variant="contained"
                  color="secondary"
                  type="submit"
                  disabled={isNewOrderBlocked || isUpdateBlocked}
                >
                  {pageProps.isEdit ? 'Update' : 'Save'} Order
                </Button>
              </Stack>
            </Form>
          </FormikProvider>
        </Container>
      </Page>

      {/* ── Delete Confirmation Dialog ─────────────────────────────── */}
      <Dialog
        open={deleteConfirmation.open}
        onClose={handleCancelDelete}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Confirm Delete
        </DialogTitle>
        <DialogContent>
          <Typography id="alert-dialog-description">
            Are you sure you want to delete this row? This action cannot be undone.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelDelete} color="error" variant="contained" disabled={isDeleting}>
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} color="secondary" variant="contained" disabled={isDeleting}>
            {isDeleting ? <CircularProgress size={18} color="inherit" /> : 'Delete'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
